<div class="container mx-auto px-0 py-0">
  <div class="bg-white rounded-lg" [ngClass]="{'shadow-md p-6': !isEmbedded, 'p-0': isEmbedded}">
    <!-- Standalone Header - Only show in standalone mode -->
    <div *ngIf="!isEmbedded" class="flex justify-between items-center mb-6">
      <div class="flex items-center space-x-2">
        <mat-icon>folder</mat-icon>
        <h2 class="text-2xl font-bold mb-0">Dokumente</h2>
      </div>
      <div class="flex justify-end">
        <button 
          (click)="addDokument()" 
          mat-stroked-button>
          <mat-icon class="mr-1">add</mat-icon>
          Dokument hinzufügen
        </button>
      </div>
    </div>
    
    <!-- Embedded Header - Only show in embedded mode -->


    <!-- Search Bar - Only show in standalone mode -->
    <div *ngIf="!isEmbedded" class="mb-4">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Suchen</mat-label>
        <input matInput [(ngModel)]="searchValue" (input)="applyFilter($event)" placeholder="Nach Dateiname, Beschreibung oder Benutzer suchen...">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="isLoadingResults" class="flex justify-center items-center py-8">
      <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
      <span class="ml-4 text-gray-600">Lade Dokumente...</span>
    </div>

    <!-- Error Message -->
    <div *ngIf="isRateLimitReached" class="text-red-500 text-center py-4">
      Fehler beim Laden der Dokumente. Bitte versuchen Sie es später erneut.
    </div>

    <!-- Documents Table -->
    <div class="mt-8 flow-root" *ngIf="!isLoadingResults && !isRateLimitReached">
      <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <table class="min-w-full divide-y divide-gray-300 dark:divide-white/15">
            <thead>
              <tr>
                <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0 dark:text-white">Dateiname</th>
                <th *ngIf="isClientView" scope="col" class="px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Standort</th>
                <th scope="col" class="px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Typ / Größe</th>
                <th scope="col" class="px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Hochgeladen von</th>
                <th scope="col" class="px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Datum</th>
                <th scope="col" class="py-3.5 pl-3 pr-4 sm:pr-0">
                  <span class="sr-only">Actions</span>
                </th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 bg-white dark:divide-white/10 dark:bg-gray-900">
              <tr 
                *ngFor="let dokument of dataSource.data; let i = index" 
                class="cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors duration-150"
                [ngClass]="{'bg-gray-50 dark:bg-gray-800': i % 2 === 1}">
                <td class="py-1 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0 dark:text-white">
                  <div class="flex items-start">
                    <mat-icon class="mr-2 text-gray-400 mt-0.5 flex-shrink-0">{{ getFileTypeIcon(dokument.mime_type) }}</mat-icon>
                    <div class="min-w-0 flex-1">
                      <div class="break-words">{{ dokument.original_filename }}</div>
                      <div *ngIf="dokument.description" class="text-xs italic text-gray-500 dark:text-gray-400 break-words">{{ dokument.description }}</div>
                    </div>
                  </div>
                </td>
                <td *ngIf="isClientView" class="px-2 py-2 text-sm text-gray-700 dark:text-gray-200">
                  <div class="break-words">{{ dokument.standort_name || '-' }}</div>
                </td>
                <td class="px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                  <div>
                    <div class="font-medium break-words">{{ getDisplayCategory(dokument.mime_type) }}</div>
                    <div class="text-xs">{{ formatFileSize(dokument.file_size) }}</div>
                  </div>
                </td>
                <td class="px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                  <div class="break-words">{{ dokument.user_full_name || dokument.user_name || 'Unbekannt' }}</div>
                </td>
                <td class="px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                  <div class="break-words">{{ dokument.uploadDate | date:'dd.MM.yyyy' }}</div>
                </td>
                <td class="py-1 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                  <div class="flex space-x-2 justify-end">
                    <button
                      (click)="downloadDokument(dokument)"
                      mat-button
                      color="primary"
                      class="slim-button flex-shrink-0">
                      Download
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Paginator -->
    <mat-paginator
      *ngIf="!isLoadingResults && !isRateLimitReached"
      [length]="totalItems"
      [pageSizeOptions]="pageSizes"
      [pageSize]="10"
      (page)="onPageChange()"
      showFirstLastButtons
      aria-label="Select page of documents">
    </mat-paginator>

    <!-- Empty State -->
    <div *ngIf="!isLoadingResults && !isRateLimitReached && dataSource.data.length === 0" class="text-center py-8">
      <mat-icon class="text-gray-400 text-6xl mb-4">folder</mat-icon>
      <p class="text-gray-500 text-lg">Keine Dokumente gefunden</p>
      <p class="text-gray-400">Fügen Sie das erste Dokument hinzu, um zu beginnen.</p>
    </div>

    <div *ngIf="isEmbedded && !isClientView && !!recordId" class="mb-4 mt-4">
        <div class="mb-4">
          <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            Dateien hochladen
          </label>
          <file-pond
            #myPond
            [options]="pondOptions"
            [files]="pondFiles"
            (oninit)="pondHandleInit()"
            (onaddfile)="pondHandleAddFile($event)"
            (onprocessfiles)="onProcessFiles($event)"
            (onactivatefile)="pondHandleActivateFile($event)">
          </file-pond>
        </div>
      </div>
  </div>
</div>
